import { findOne } from 'rcd-cpp-workspace/utils/array';
import * as React from 'react';
import { FilterProps } from '../filters';
import './numberFilter.scss';
import { Op } from '../../../enums/Op';
import { parseCondition } from '../../../utils';
import { Options } from '../Options/options';
import { AdminDomain } from '../../../enums/AdminDomain';
import { DataType } from '../../../enums/DataType';

const OPTIONS = [
  Op.equals,
  Op.greaterThan,
  Op.lessThan,
  Op.between,
  Op.isEmpty,
  Op.isNotEmpty,
  Op.multiValue
];

export const NumberFilter = ({
  filter,
  field,
  setFilter,
  schema
}: FilterProps) => {
  const filteredOptions = [...OPTIONS];
  if (
    schema?.id == AdminDomain.stagedTags &&
    field.dataType == DataType.number
  ) {
    filteredOptions.splice(filteredOptions.indexOf(Op.multiValue), 1);
  }
  const curFilter = filter; // findOne(filters, { field: filter.field });
  let conditions = [];
  if (curFilter.conditions) conditions = curFilter.conditions;
  const { op, val } = parseCondition(curFilter.conditions, filteredOptions[0]);
  const initializeMultiValue = () => {
    const multiVal = val ? (Array.isArray(val) ? val.join(', ') : val) : '';
    return Op.multiValue && multiVal ? multiVal : '';
  };

  const [multiValueInput, setMultiValueInput] = React.useState(
    initializeMultiValue()
  );
  const [recognizedCount, setRecognizedCount] = React.useState(
    Op.multiValue && Array.isArray(val) ? val.length : 0
  );
  const showInput =
    op != Op.isEmpty &&
    op != Op.isNotEmpty &&
    op != Op.multiValue &&
    op != Op.between;

  React.useEffect(() => {
    if (op == Op.multiValue) {
      const values = multiValueInput
        .split(/[\n, ]+/)
        .filter(v => /^-?\d+$/.test(v.trim()))
        .map(Number);

      if (JSON.stringify(values) != JSON.stringify(val)) {
        setRecognizedCount(values.length);
        setFilter({ ...curFilter, conditions: [{ [Op.multiValue]: values }] });
        setMultiValueInput(values.join(', '));
      }
    }
  }, [val, multiValueInput]);

  return (
    <div className="filter-box number-filter">
      <div>
        {field.name}&nbsp;
        <Options
          options={filteredOptions}
          onSelect={option => {
            if ([Op.isEmpty, Op.isNotEmpty].includes(option)) {
              setFilter({ ...curFilter, conditions: [{ [option]: true }] });
            } else if (option == Op.multiValue) {
              setFilter({
                ...curFilter,
                conditions: [{ [option]: '' }]
              });
              setMultiValueInput('');
              setRecognizedCount(0);
            } else if (option == Op.between) {
              setFilter({
                ...curFilter,
                conditions: [{ [option]: ['', ''] }]
              });
            } else {
              setFilter({
                ...curFilter,
                conditions: [{ [option]: typeof val == 'string' ? val : '' }]
              });
            }
          }}
          selected={op}
        />
      </div>
      <div>
        {op == Op.between ? (
          <div className="between-container">
            <input
              type="number"
              value={Array.isArray(val) ? val[0] || '' : ''}
              onChange={e => {
                const min = e.target.value;
                const max = Array.isArray(val) ? val[1] : '';
                setFilter(
                  { ...curFilter, conditions: [{ [op]: [min, max] }] },
                  true
                );
              }}
            />
            -
            <input
              type="number"
              value={Array.isArray(val) ? val[1] || '' : ''}
              onChange={e => {
                const min = Array.isArray(val) ? val[0] : '';
                const max = e.target.value;
                setFilter(
                  { ...curFilter, conditions: [{ [op]: [min, max] }] },
                  true
                );
              }}
            />
          </div>
        ) : (
          showInput && (
            <input
              type="number"
              value={val}
              onChange={(e: any) => {
                let value = e.target.value;
                setFilter(
                  { ...curFilter, conditions: [{ [op]: value }] },
                  true
                );
              }}
            />
          )
        )}
        {op == Op.multiValue && (
          <div className="multi-value-container">
            <textarea
              value={multiValueInput}
              onChange={e => setMultiValueInput(e.target.value)}
              placeholder="Enter values separated by commas, spaces, or new lines"
            />
            <div className="recognized-count">Count: {recognizedCount}</div>
          </div>
        )}
      </div>
    </div>
  );
};
